<template>
  <DsModal
    :open="true"
    :full-screen="true"
    :title="$t('components.GlobalFilterModal.label.title')"
    :text="$t('components.GlobalFilterModal.label.description')"
    :link-label="$t('components.GlobalFilterModal.label.button.clearButton')"
    :primary-button-label="$t('components.GlobalFilterModal.label.button.confirmButton')"
    :secondary-button-label="$t('components.GlobalFilterModal.label.button.cancelButton')"
    @link="clearAction()"
    @secondary="cancelAction()"
    @primary="confirmAction()"
  >
    <template slot="content">
      <div class="global-filter-modal">
        <div class="global-filter-modal__listening">
          <div class="global-filter-modal__title global-filter-modal__title--listening">
            {{ $t('components.GlobalFilterModal.label.listening.subtitle') }}
          </div>

          <div>
            <div class="global-filter-modal__label">
              {{ $t('components.GlobalFilterModal.label.listening.session.what') }}
            </div>

            <v-row
              no-gutters
              class="justify-space-between"
            >
              <v-col
                v-for="(filter, index) in filtersListeningObj"
                :key="index"
                cols="12"
                md="3"
                class="global-filter-modal__input"
              >
                <v-row
                  no-gutters
                >
                  <component
                    :is="filter.component"
                    v-model="tempFilter[filter.filterType]"
                    v-bind="filter.props"
                  />
                </v-row>
              </v-col>
            </v-row>
          </div>

          <div>
            <v-row
              dense
            >
              <v-col>
                <v-row
                  no-gutters
                >
                  <v-col>
                    <div class="global-filter-modal__label">
                      {{ $t('components.GlobalFilterModal.label.listening.session.when') }}
                    </div>

                    <DateFilter
                      v-model="modalDateRange"
                      class="global-filter-modal__input global-filter-modal__input--date-filter"
                      :primary-btn-label="$t('components.GlobalFilterModal.label.button.primaryButton')"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row
                  no-gutters
                >
                  <v-col>
                    <div class="global-filter-modal__label">
                      {{ $t('components.GlobalFilterModal.label.listening.session.where') }}
                    </div>

                    <ChannelFilter
                      v-model="tempFilter['channels_listening']"
                      :data-type="dataTypeListening"
                      class="global-filter-modal__input"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row
                  no-gutters
                >
                  <v-col>
                    <div class="global-filter-modal__label">
                      {{ $t('components.GlobalFilterModal.label.listening.session.who') }}
                    </div>

                    <UserFilter
                      v-model="tempFilter['uids']"
                      class="global-filter-modal__input"
                      v-bind="getUIDProps"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <v-col />
            </v-row>
          </div>
        </div>
        <div class="global-filter-modal__sac">
          <div class="global-filter-modal__title global-filter-modal__title--sac">
            {{ $t('components.GlobalFilterModal.label.sac.subtitle') }}
          </div>

          <div>
            <v-row
              no-gutters
              class="justify-space-between"
            >
              <v-col
                cols="12"
                md="3"
                class="global-filter-modal__input"
              >
                <v-row
                  no-gutters
                >
                  <PageFilter
                    v-model="tempFilter['pages']"
                    :pages-items="pagesFormatted"
                  />
                </v-row>
              </v-col>

              <v-col
                v-for="(filter, index) in filtersSacObj"
                :key="index"
                cols="12"
                md="3"
                class="global-filter-modal__input"
              >
                <v-row
                  no-gutters
                >
                  <component
                    :is="filter.component"
                    v-model="tempFilter[filter.filterType]"
                    v-bind="filter.props"
                    :channels="channels"
                  />
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="global-filter-modal__blip">
          <div class="global-filter-modal__title global-filter-modal__title--sac">
            {{ $t('components.GlobalFilterModal.label.blip.subtitle') }}
          </div>
          <div>
            <v-row
              dense
            >
              <v-col
                v-for="(filter, index) in filtersBlip"
                :key="index"
                cols="3"
              >
                <v-row
                  no-gutters
                >
                  <v-col
                    class="global-filter-modal__input"
                  >
                    <component
                      :is="filter.component"
                      v-model="tempFilter[filter.filterType]"
                      v-bind="filter.props"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
        <ModalAlert
          v-if="showTikTokAlert"
          class="mt-auto"
          :alert-message="alertMessage"
          :link-text="linkText"
          :link-reference="linkReference"
          @close-alert="closeAlert()"
        />
      </div>
    </template>
  </DsModal>
</template>

<script>
import { DsModal } from '@ds/components';
import StIcon from '@stilingue/st-icon';
import DateFilter from '@/components/DateFilter';
import ModalAlert from '@/components/ModalAlert';
import ChannelFilter from '@/components/filter/ChannelFilter';
import NegativationFilter from '@/components/filter/NegativationFilter';
import SentimentFilter from '@/components/filter/SentimentFilter';
import UserFilter from '@/components/filter/UserFilter';
import DarkPostFilter from '@/components/filter/DarkPostFilter';

import PageFilter from '@/components/filter/PageFilter';
import StatusFilter from '@/components/filter/StatusFilter';
import SacTypeFilter from '@/components/filter/SacTypeFilter';
import RepliersFilter from '@/components/filter/RepliersFilter';

import ContractFilter from '@/components/filter/ContractFilter';
import BotFilter from '@/components/filter/BotFilter';
import CategoryFilter from '@/components/filter/CategoryFilter';

import filtersModel from '@/mixins/filters-model';
import pagesModel from '@/mixins/pages-model';
import blipModel from '@/mixins/blip-model';
import repliersModel from '@/mixins/repliers-model';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { MUTATE } from '@/store/modules/mutation_types';
import moment from 'moment';
import { NORMALIZED_PATTERN } from '@/utils/date';
import { isEqual, cloneDeep } from 'lodash';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import { DATA_TYPE, FILTER_NAMES } from '@/store/modules/cards/constants';
import EventBus from '@/utils/event-bus';

const validateSelectedForTikTok = (fieldContext) => {
  if (Boolean(fieldContext.selectedValues.length)) EventBus.$emit('clearTikTokPages');
};

export default {
  name: 'GlobalFilterModal',
  components: {
    DsModal,
    StIcon,
    NegativationFilter,
    SentimentFilter,
    DarkPostFilter,
    DateFilter,
    ModalAlert,
    ChannelFilter,
    UserFilter,
    PageFilter,
    SacTypeFilter,
    StatusFilter,
    RepliersFilter,
    ContractFilter,
    BotFilter,
    CategoryFilter,
  },
  mixins: [
    pagesModel,
    repliersModel,
    filtersModel,
    blipModel,
  ],
  data() {
    return {
      appliedFilter: {},
      tempFilter: {},
      channels: [],
      modalDateRange: {},
      dataTypeListening: DATA_TYPE.LISTENING,
      tikTokAlertRule: false,
      showTikTokAlert: false,
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeGlobalFilter',
      'activeDashboardFilters',
    ]),
    ...mapState('filter', [
      'dateRange',
    ]),
    filtersListeningObj() {
      const themeItems = [
        {
          text: 'Não Classificados',
          value: 'Sem Temas',
          shouldIgnore: false,
          hasIgnoreOption: true,
        },
        ...(this.activeDashboardFilters?.themes?.map(value => this.generateObjectToNegativationFilter(value)) || []),
      ];

      const tagItems = [
        {
          text: 'Não Classificados',
          value: 'Sem Tags',
          shouldIgnore: false,
          hasIgnoreOption: true,
        },
        ...(this.activeDashboardFilters?.tags?.map(value => this.generateObjectToNegativationFilter(value)) || []),
      ];

      const namesItems = [
        {
          text: 'Não Classificados',
          value: 'Sem Grupos',
          shouldIgnore: false,
          hasIgnoreOption: true,
        },
        ...(this.activeDashboardFilters?.names?.map(value => this.generateObjectToNegativationFilter(value)) || []),
      ];

      return [
        {
          component: 'NegativationFilter',
          filterType: FILTER_NAMES.GROUP,
          props: {
            label: 'Grupos',
            selectItems: namesItems,
            searchable: true,
          },
        },
        {
          component: 'NegativationFilter',
          filterType: FILTER_NAMES.THEME,
          props: {
            label: 'Temas',
            selectItems: themeItems,
            searchable: true,
            validate() {
              validateSelectedForTikTok(this);
            },
          },
        },
        {
          component: 'NegativationFilter',
          filterType: FILTER_NAMES.TAG,
          props: {
            label: 'Tags',
            selectItems: tagItems,
            searchable: true,
            validate() {
              validateSelectedForTikTok(this);
            },
          },
        },
        {
          component: 'SentimentFilter',
          filterType: FILTER_NAMES.POLARITY,
        },
        {
          component: 'DarkPostFilter',
          filterType: FILTER_NAMES.DARK_POST,
        },
      ];
    },
    filtersSacObj() {
      return [
        {
          component: 'SacTypeFilter',
          filterType: FILTER_NAMES.SAC_TYPE,
        },
        {
          component: 'StatusFilter',
          filterType: FILTER_NAMES.SAC_STATUS,
          props: {
            label: 'Status',
          },
        },
        {
          component: 'RepliersFilter',
          filterType: FILTER_NAMES.SAC_REPLIER,
          props: {
            label: 'Respondentes',
            selectItems: this.repliersToSelectItem(this.activeDashboardFilters?.repliers),
          },
        },
      ];
    },
    filtersBlip() {
      return [
        {
          component: 'ContractFilter',
          filterType: FILTER_NAMES.CONTRACTS,
          props: {
            label: 'Contrato',
            items: this.contractFilterItems,
          },
        },
        {
          component: 'BotFilter',
          filterType: FILTER_NAMES.BOTS,
          props: {
            label: 'Bot',
            items: this.botFilterItems,
          },
        },
        {
          component: 'CategoryFilter',
          filterType: FILTER_NAMES.CATEGORY,
          props: {
            label: 'Categoria',
            items: this.categoryFilterItems,
          },
        },
      ];
    },
    getUIDProps() {
      return this.activeDashboardFilters?.uid || [];
    },
  },
  watch: {
    'tempFilter.pages': {
      handler(newPages, oldPages) {
        if (!isEqual(oldPages, newPages) && Boolean(newPages?.value?.length)) {
          const channelsSet = new Set(this.pagesFormatted
            .filter(({ value }) => newPages?.value.includes(value))
            .map(({ channel }) => channel));

          const channels = Array.from(channelsSet);

          this.channels = channels;
          this.tempFilter.channels = { value: channels };
        }

        if (!isEqual(oldPages, newPages) && !Boolean(newPages?.value?.length)) {
          delete this.tempFilter.channels;
          delete this.tempFilter.pages;
        }
      },
      deep: true,
    },
    'tempFilter.contracts': {
      handler(newContract, oldContract) {
        if (Boolean(oldContract?.value) && newContract?.value !== oldContract?.value) {
          delete this.tempFilter.bots;
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.activeGlobalFilter) {
      this.appliedFilter = cloneDeep(this.activeGlobalFilter);
      this.tempFilter = cloneDeep(this.activeGlobalFilter);
    }
    this.modalDateRange = this.dateRange;

    this.channels = this.tempFilter.channels?.value || [];

    EventBus.$on('changedPages', () => {
      if (this.tempFilter?.pages?.value?.some(page => this.tikTokPages.includes(page)) &&
        this.isSentimentThemeTagSelected(this.tempFilter)) EventBus.$emit('clearTikTokPages');
    });

    EventBus.$on('showTikTokAlert', () => {
      this.showTikTokAlert = true;
    });
  },
  methods: {
    ...mapMutations('filter', {
      mutateFilter: MUTATE,
    }),
    ...mapActions('dashboard', [
      'saveGlobalFilter',
    ]),
    hasDateChange() {
      return this.dateHasChange(this.modalDateRange, this.dateRange);
    },
    hasFilterChange(filters) {
      return !isEqual(filters.oldFilter, filters.newFilter);
    },
    checkHasSacTypeAll(value) {
      return value.hasOwnProperty(FILTER_NAMES.SAC_TYPE) ? Boolean(value.sac_type.value[0] === 'All') : false;
    },
    verifyChanges(filters) {
      const trackInfo = {
        Field: '',
        DateRange: '',
      };

      const values = filters.newFilter ? { ...filters.newFilter } : {};
      if (this.hasFilterChange(filters)) {
        const changedFilters = Object.keys(this.differenceBetweenTwoObject(filters.oldFilter, filters.newFilter));
        trackInfo.Field = this.applyFallbackToFilters(changedFilters);
      }

      this.mutateFilter({
        property: 'globalFilter',
        with: values,
      });

      const hasSacTypeAll = this.checkHasSacTypeAll(values);
      if (hasSacTypeAll) {
        delete values.sac_type;
      }

      this.saveGlobalFilter(values);

      if (this.hasDateChange()) {
        this.mutateFilter({
          property: 'dateRange',
          with: {
            start: moment(this.modalDateRange.start, NORMALIZED_PATTERN),
            end: moment(this.modalDateRange.end, NORMALIZED_PATTERN),
          },
        });

        trackInfo.DateRange = this.modalDateRange.period;
      }

      trackEventWithUserProperties('ST GlobalFilter Modal Edit', { Field: trackInfo });
    },
    clearAction() {
      this.tempFilter = {};
      this.appliedFilter = {};

      this.modalDateRange = {
        start: moment().subtract('6', 'day').startOf('day'),
        end: moment().endOf('day'),
        period: 'Custom',
      };
    },
    cancelAction() {
      this.$emit('cancel');
    },
    confirmAction() {
      // Sanatize before send
      for (const filter in this.tempFilter) {
        if (!this.tempFilter[filter] || (!this.tempFilter[filter]?.value && this.tempFilter[filter]?.value?.length)) {
          delete this.tempFilter[filter];
        }
      }

      const filters = {
        modalDateRange: this.modalDateRange,
        stickyDateRange: this.dateRange,
        oldFilter: this.appliedFilter,
        newFilter: this.tempFilter,
      };

      const changes = this.hasChange(filters);
      if (changes) {
        this.verifyChanges(filters);
      }

      this.$emit('confirm', changes);
    },
    generateObjectToFilter(value) {
      return {
        text: value,
        value,
      };
    },
    closeAlert() {
      this.showTikTokAlert = !this.showTikTokAlert;
    },
    hasChange(filters) {
      return this.hasFilterChange(filters) || !this.tempFilter.length || this.hasDateChange();
    },
  },
};
</script>

<style scoped lang="scss">
$input-size: 287px;

.global-filter-modal {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__listening,
  &__sac {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-md);
    line-height: 24px;

    &--listening {
      padding: var(--ds-spacing-stack-nano) 0 var(--ds-spacing-stack-sm) 0;
    }

    &--sac {
      padding: var(--ds-spacing-stack-xs) 0 var(--ds-spacing-stack-sm) 0;
    }
  }

  &__label {
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-baseline);
    line-height: 24px;
    padding-bottom: var(--ds-spacing-stack-xs);
  }

  &__input {
    padding: 7px 0 var(--ds-spacing-inline-md) 0;
    line-height: 24px;
    max-width: $input-size;

    &--date-filter {
      padding-top: 0;
    }
  }
}

::v-deep {
  .ds-modal {
    &__component {
      padding: 0 calc((100vw - 1196px) / 2);
      background-color: var(--ds-color-surface-contrast);
    }

    &__header,
    &__footer {
      padding-right: 0;
      padding-left: 0;
      overflow: hidden;
    }

    &__container {
      padding-right: 0;
      padding-left: 0;
      overflow: hidden;
      height: 100%;
    }

    &__slot-content {
      height: calc(100% - 36px);
    }

    &__text {
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-sm);
      color: var(--ds-color-text-2);
      line-height: 20px;
    }
  }

  .v-select__selections input {
    display: inline !important;
  }
}
</style>
